<template>
  <v-dialog v-model="dialog" max-width="500px">
    <template v-slot:activator="{ on }">
      <a class="float-right" v-on="on">Forgotten Password?</a>
    </template>
    <v-card>
      <v-card-title>Reset Password</v-card-title>

      <v-form ref="form" v-model="valid" @submit.prevent="sendPasswordReset">
        <v-card-text>
          Please enter your email address below and we'll send you a link to
          reset your password.
          <v-text-field
            class="mt-4"
            v-model="emailAddress"
            :rules="emailAddressRules"
            label="Email Address"
            type="email"
            required
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            type="button"
            color="blue darken-1"
            text
            @click="dialog = false"
            >Close</v-btn
          >
          <v-btn type="submit" color="blue darken-1" text>Send</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import UserService from "@/services/UserService.js";

export default {
  name: "ForgottenPassword",
  data() {
    return {
      dialog: false,
      valid: true,
      emailAddress: "",
      emailAddressRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ]
    };
  },
  methods: {
    async sendPasswordReset() {
      if (this.$refs.form.validate()) {
        await UserService.sendPasswordReset({
          emailAddress: this.emailAddress
        });

        this.dialog = false;
      }
    }
  },
  watch: {
    dialog: function() {
      if (!this.dialog) {
        this.$refs.form.reset();
      }
    }
  }
};
</script>

<style scoped></style>
